import { ToastService } from '@agilox/components';
import { inject, Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { first } from 'rxjs';
import { BoardType } from '../../../enums/board-type.enum';
import { AppsettingsService } from '../appsettings/appsettings.service';
import { BoardService } from '../board/board.service';
import { DashboardFilterService } from '../dashboard-filter/dashboard-filter-service';

@Injectable({
	providedIn: 'root',
})
export class ChartMigrationService {
	private readonly toastService = inject(ToastService);
	private readonly translate = inject(TranslateService);
	private readonly appSettingsService = inject(AppsettingsService);
	private readonly boardService = inject(BoardService);
	private readonly dashboardFilterService = inject(DashboardFilterService);

	migrateExistingWidgets(): void {
		const webAppSettings = this.appSettingsService.webAppSettings;
		const userGeneratedWidgets = webAppSettings.userGeneratedWidgets;
		const indicatorWidgets = webAppSettings.indicatorWidgets;
		const boards = this.boardService.boards();

		if (boards.length > 0 || (!userGeneratedWidgets.length && !indicatorWidgets.length)) {
			return;
		}

		this.dashboardFilterService
			.getDefaultFilter()
			.pipe(first())
			.subscribe((filter) => {
				this.boardService.createBoard({
					name: this.translate.instant('general.menu.dashboard'),
					type: BoardType.DASHBOARD,
					dashboardFilter: filter,
					userGeneratedWidgets,
				});

				this.boardService.createBoard({
					name: this.translate.instant('general.menu.statusboard'),
					type: BoardType.STATUSBOARD,
					indicatorWidgets,
				});

				this.toastService.show(
					this.translate.instant('widget.migrate.migrate_all_widgets_success'),
					'success'
				);

				webAppSettings.isWidgetMigrationComplete = true;
				this.appSettingsService.saveAppSettingsOnServer();
			});
	}

	isWidgetMigrationComplete(): boolean {
		const webAppSettings = this.appSettingsService.webAppSettings;
		return webAppSettings.isWidgetMigrationComplete;
	}
}
